export let hrms6keColumns = () => {
  let indexColumns = [
    {
      key: 'numotgen',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 200px;',
      dataType: 'date'
    }, {
      key: 'timbstr',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'timdstr',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'timastr',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRMS6KEC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }
  ]
  let detailTab2TableColumns = [
    {
      key: 'dtestrt',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 150px;',
      inlineType: 'date',
      eventName: 'dtestrt',
      validateRules: 'requiredWhenExist:codempid|date_format:DD/MM/YYYY',
      dataType: 'date'
    }, {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 150px;',
      inlineType: 'lov',
      lovType: 'codempid',
      eventName: 'codempid',
      inlineFlgEditDisabled: true,
      validateRules: 'required'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'typot',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '50',
      inlineType: 'select',
      inlineDropdown: {},
      class: 'align-center',
      style: 'min-width: 150px;',
      validateRules: 'required'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'v_timstrt',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 150px;',
      inlineType: 'time',
      validateRules: 'required|date_format:HH:mm'
    }, {
      key: 'v_timend',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 150px;',
      inlineType: 'time',
      validateRules: 'required|date_format:HH:mm'
    }, {
      key: 'v_staappr',
      name: '',
      labelCodapp: 'HRMS6KEC3',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2Table: detailTab2TableColumns
    },
    th: {
      index: indexColumns,
      detailTab2Table: detailTab2TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms6ke.js